import classNames from "classnames"
import { storyblokEditable } from "gatsby-source-storyblok"

import React, { useState } from "react"

const DEFAULT_VISIBLE_ROWS = 6

const StoryblokSpecificationTable = ({
  blok,
}: Storyblok.BlokProps<Storyblok.SpecificationTable>) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const rows = blok.data?.tbody || []
  const hasMoreThanDefault = rows.length > DEFAULT_VISIBLE_ROWS
  const visibleRows = isExpanded ? rows : rows.slice(0, DEFAULT_VISIBLE_ROWS)

  return (
    <div
      className={classNames("w-full", hasMoreThanDefault ? "pb-0" : "pb-16")}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      <div className="relative">
        <div className="divide-y divide-gray overflow-hidden rounded-16 border border-gray">
          {visibleRows.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              className="grid grid-cols-1 text-body-md md:grid-cols-[200px_1fr]"
            >
              <div className="bg-light-gray px-16 py-10">
                {row.body[0]?.value}
              </div>
              <div className="px-16 py-10">{row.body[1]?.value}</div>
            </div>
          ))}
        </div>
        {!isExpanded && hasMoreThanDefault && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-80 bg-gradient-to-t from-white to-transparent" />
        )}
      </div>
      {hasMoreThanDefault && (
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-16 cursor-pointer text-blue underline"
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  )
}

export default StoryblokSpecificationTable
